export default __webpack_public_path__ + "static/media/04_photo.4c688f5e.jpg";